// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"9425ca93","455":"c148ed2e","977":"3dd57dd6"}[chunkId] + ".chunk.js";
};